// Optional Book Structure suggestions only: nothing is persisted until a writer
// saves readable text. Never construct blank snapshot/Matter records from these.
export const NOVEL_FRONT_MATTER_TEMPLATES = Object.freeze([
  { title: "Title Page", fr: "Page de titre" },
  { title: "Subtitle", fr: "Sous-titre" },
  { title: "Copyright", fr: "Droits d’auteur" },
  { title: "Dedication", fr: "Dédicace" },
  { title: "Epigraph", fr: "Épigraphe" },
  { title: "Foreword", fr: "Avant-propos" },
  { title: "Preface", fr: "Préface" },
  { title: "Acknowledgments", fr: "Remerciements" },
  { title: "Introduction", fr: "Introduction" },
  { title: "Table of Contents", fr: "Table des matières" },
]);

export const NOVEL_BACK_MATTER_TEMPLATES = Object.freeze([
  { title: "Afterword", fr: "Postface" },
  { title: "Appendix", fr: "Annexe" },
  { title: "Glossary", fr: "Glossaire" },
  { title: "Endnotes", fr: "Notes de fin" },
  { title: "References / Bibliography", fr: "Références / Bibliographie" },
  { title: "About the Author", fr: "À propos de l’auteur" },
  { title: "Other Books by the Author", fr: "Autres livres de l’auteur" },
  { title: "Index", fr: "Index" },
]);

export function normalizedNovelMatterTitle(title) {
  const v = String(title ?? "").trim().toLocaleLowerCase().replace(/[’']/g, "'")
    .replace(/[^a-z0-9\u00c0-\u024f]+/gi, " ").trim().replace(/\s+/g, " ");
  if (["title", "book title", "title page", "page de titre"].includes(v)) return "title-page";
  if (["subtitle", "sub title", "sous titre"].includes(v)) return "subtitle";
  if (["about author", "about the author", "a propos de l auteur"].includes(v)) return "author-bio";
  if (["acknowledgements", "acknowledgments"].includes(v)) return "acknowledgments";
  if (["references", "bibliography", "references bibliography"].includes(v)) return "references-bibliography";
  return v;
}

export function existingNovelMatterTemplate(items, template) {
  const key = normalizedNovelMatterTitle(template?.title);
  return (Array.isArray(items) ? items : []).find(item =>
    normalizedNovelMatterTitle(item?.title) === key ||
    normalizedNovelMatterTitle(item?.title) === normalizedNovelMatterTitle(template?.fr)
  ) || null;
}

export function hasReadableNovelMatterBody(item) {
  if (String(item?.text ?? "").trim()) return true;
  return (Array.isArray(item?.manuscriptContent?.blocks) ? item.manuscriptContent.blocks : [])
    .some(block => String(block?.text ?? "").trim() ||
      (Array.isArray(block?.runs) ? block.runs : [])
        .some(run => String(run?.text ?? "").trim()));
}
